<!-- =========================================================================================
    File Name: ProductUnitAddNew.vue
    Description: Add new Product Unit
    ----------------------------------------------------------------------------------------
    Item Name: Vaagai Tecknowledge - Easy Admin
    Author: Web Team
    Author URL: http://www.vaagai.org.in/
========================================================================================== -->


<template>
    <div class="px-6 pb-2 pt-6">

        <h4> Add Product Unit </h4> <br/>        

        <div class="p-6">
            
            <form @submit.prevent="submitForm">

                <div class="vx-row">
                    <div class="vx-col sm:w-1/2 w-full mb-3">
                        <span>Unit Name</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-3">
                        <vs-input class="w-full" v-model="UnitName" v-validate="'required'" name="UnitName" icon-pack="fa" icon="fa-pen-square" />
                        <span class="text-danger text-sm" v-show="errors.has('UnitName')">{{ errors.first('UnitName') }}</span>
                    </div>
                </div>

                <div class="vx-row">
                    <div class="vx-col sm:w-1/2 w-full mb-3">
                        <span>Unit Symbol</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-3">
                        <vs-input class="w-full" v-model="UnitSymbol" v-validate="'required'" name="UnitSymbol" icon-pack="fa" icon="fa-balance-scale" />
                        <span class="text-danger text-sm" v-show="errors.has('UnitSymbol')">{{ errors.first('UnitSymbol') }}</span>
                    </div>
                </div>

                <div class="vx-row">
                    <div class="vx-col sm:w-1/2 w-full mb-3">
                        <span>Regional Name</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-3">
                        <vs-input class="w-full" v-model="UnitRegionalName" name="UnitRegionalName" icon-pack="fa" icon="fa-language" />
                        <span class="text-danger text-sm" v-show="errors.has('UnitRegionalName')">{{ errors.first('UnitRegionalName') }}</span>
                    </div>
                </div>

                <div class="vx-row">
                    <div class="vx-col w-full text-right mb-3">
                        <vs-button type="filled" @click.prevent="submitForm" class="mr-3 mb-2"> {{ $t("SubmitButton") }} </vs-button>
                        <vs-button color="warning" type="border" class="mb-2" @click.prevent="closePrompt" > {{ $t("CancelButton") }} </vs-button>
                    </div>
                </div>
                
            </form>
        </div>
    </div>
</template>

<script>

import companyConfig from '@/company_config.json'
// import common from '@/views/Common.vue'

export default {
    props: {
        addRecordPrompt: {
            type: Boolean,
            required: true,
        },
    },    
    data() {
        return {
            // activePrompt: false,

            UnitName : '',
            UnitRegionalName : '',
            UnitSymbol : '',

            record: {},
        }
    },
    computed: {
        dataArrayLength() {
            return this.$store.getters['productUnit/dataArrayLength'];
        },
    },
    methods: {
        closePrompt() {
            console.log('closePrompt called');
            this.$emit('hideAddRecordPrompt');
        },        
        addRecordDetails() {
            // add todo in store and clear all fields in dialog

            var recordObj = {
                "UnitName" :  this.UnitName, 
                "UnitRegionalName" :  this.UnitRegionalName, 
                "UnitSymbol" :  this.UnitSymbol, 
            };

            var server_url=companyConfig.apiURL;
            this.record.token=this.$session.get('token');
            this.record.add_url=server_url+'lib/api/product/productunit/create';
            this.record.form=recordObj;
            this.record.list_url=server_url+'lib/api/product/productunit/lists';
            this.record.list_where={};
            console.log('record='+JSON.stringify(this.record));
            this.record.loading=this.$vs.loading;
            this.record.notify=this.$vs.notify;
            this.record.http=this.$http;            
            this.$store.dispatch('productUnit/addRecordDetails', this.record);

            this.closePrompt();
        },
        clearFields() {
            // clear all fileds in todo
            this.UnitName =  '';
            this.UnitRegionalName =  '';
            this.UnitSymbol =  '';

            this.$parent.addRecordPrompt = false;
        },
        submitForm() {
            this.$validator.validateAll().then(result => {
                if (result) this.addRecordDetails();
            })
        }
    },
}
</script>
